var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',{staticClass:"c-table-body"},_vm._l((_vm.data),function(row,rowIndex){return _c('tr',{key:rowIndex},_vm._l((_vm.columns),function(column,columnIndex){return _c('td',{key:columnIndex},[_vm._v(" "+_vm._s(row[column])+" ")])}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }